/*
 * Copyright (c) 2021. Lukas Tschaftary
 *
 * NOTICE:  All information contained herein is, and remains the property of Lukas Tschaftary and his suppliers, if any.
 * The intellectual and technical concepts contained herein are proprietary to Lukas Tschaftary and its suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained from Lukas Tschaftary.
 */

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {IoChevronDownSharp, IoCloseSharp} from "react-icons/io5";
import {IoSearchOutline} from "react-icons/io5";

class TextInput extends Component {


    render() {
        return (
            <>
                {(this.props.label !== undefined) && (
                    <label className="block text-sm font-medium text-gray-700 mb-1">{this.props.label}</label>)}
                <div className=" relative rounded-md shadow-sm" style={{...this.props.style}}>
                    {this.props.isReadOnly ? (
                        <div className={"px-3  sm:text-sm rounded-sm cursor-default text-gray-600 h-10 w-full "}
                             ref={this.props.innerRef}
                             style={{paddingBottom: 9, paddingTop: 9}}>
                            {this.props.value || this.props.placeholder}
                        </div>) : (
                        <input type={this.props.type || "text"} style={{caretColor: "rgba(96, 165, 250, 100)"}}
                               autoComplete={"off"}
                               ref={this.props.innerRef}
                               value={this.props.value}
                               onChange={(value, event) => {
                                   if (this.props.onChange !== undefined) {
                                       this.props.onChange(value.target.value)
                                   }
                               }}
                               onFocus={() => {
                                   if (this.props.onFocus !== undefined) {
                                       this.props.onFocus()
                                   }
                               }}
                               onBlur={() => {
                                   if (this.props.onBlur !== undefined) {
                                       this.props.onBlur()
                                   }
                               }}
                               onKeyDown={(event) => {
                                   if (this.props.onKeyDown !== undefined) {
                                       this.props.onKeyDown(event)
                                   }
                               }}
                               onClick={(event) => {
                                   if (this.props.onClick !== undefined) {
                                       this.props.onClick(event)
                                   }
                               }}
                               onFocusCapture={(event) => {
                                   if (this.props.onFocusCapture !== undefined) {
                                       this.props.onFocusCapture(event)
                                   }
                               }}

                               className=" focus:ring-blue-300 focus:border-blue-300 hover:border-gray-400 block w-full sm:text-sm border-gray-300 bg-gray-50 bg-opacity-25 rounded-sm placeholder-opacity-10 "
                               placeholder={this.props.placeholder}/>)}


                    <div className="absolute inset-y-0 right-0  space-x-3 flex items-center pointer-events-none">
                        {/*right textbox extension*/}
                        {this.props.hasDot && (<>
                            <span className="relative inline-flex rounded-full h-2 w-2"
                                  style={{background: this.props.dotColor}}/>
                            {this.props.dotAnimated && (<span
                                className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-purple-400 opacity-75"/>)}
                        </>)}

                        {this.props.hasArrow && (<>
                            <IoChevronDownSharp className="relative inline-flex rounded-full h-3 w-3"
                                                style={{color: this.props.arrowColor}}/>
                            {this.props.arrowAnimated && (
                                <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full  opacity-30 "
                                      style={{background: this.props.arrowColor}}/>)}
                        </>)}

                        {this.props.hasSearch && (<>
                            <IoSearchOutline className="relative inline-flex rounded-full h-4 w-4"
                                             style={{color: this.props.searchColor}}/>
                            {this.props.searchAnimated && (
                                <span className="animate-ping absolute inline-flex h-4 w-4 rounded-full  opacity-30 "
                                      style={{background: this.props.searchColor}}/>)}
                        </>)}

                        {this.props.hasClose && (<>
                            <IoCloseSharp
                                className="relative inline-flex rounded-full h-4 w-4 cursor-pointer pointer-events-auto"
                                onClick={() => {
                                    if (this.props.onCloseClick !== undefined) {
                                        this.props.onCloseClick()
                                    }
                                }}
                                style={{color: this.props.closeColor}}/>
                            {this.props.closeAnimated && (
                                <span className="animate-ping absolute inline-flex h-4 w-4 rounded-full  opacity-30 "
                                      style={{background: this.props.closeColor}}/>)}
                        </>)}

                        <span className={'pointer-events-auto'}>
                        {(this.props.extend !== undefined) && (this.props.extend)}
                        </span>

                    </div>

                </div>
            </>
        );
    }
}

TextInput.propTypes = {
    value: PropTypes.any,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isReadOnly: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    onClick: PropTypes.func,
    onFocusCapture: PropTypes.func,
    innerRef: PropTypes.element,
    hasDot: PropTypes.bool,
    dotColor: PropTypes.string,
    dotAnimated: PropTypes.bool,
    hasArrow: PropTypes.bool,
    arrowColor: PropTypes.string,
    arrowAnimated: PropTypes.bool,
    hasClose: PropTypes.bool,
    closeColor: PropTypes.string,
    closeAnimated: PropTypes.bool,
    onCloseClick: PropTypes.func,
    extend: PropTypes.element,
    hasSearch: PropTypes.bool,
    searchColor: PropTypes.string,
    searchAnimated: PropTypes.bool,
};
TextInput.defaultProps = {
    isReadOnly: false,
    placeholder: '---',
    hasDot: false,
    dotColor: '#a7a7a7',
    dotAnimated: false,
}

export default TextInput;